/* The sticky action takes shoppers to the actual variant controls and purchase form. */
(() => {
  const section = document.querySelector('[data-section-type="product-template"]');
  const form = section?.querySelector('.product-detaitls_form');
  const bar = document.querySelector('[data-kp-product-sticky]');
  if (!form || !bar || !('IntersectionObserver' in window)) return;
  const mobile = matchMedia('(max-width: 991px)');
  let passed = false, footerVisible = false;
  const update = () => { bar.hidden = !mobile.matches || !passed || footerVisible; };
  new IntersectionObserver(([entry]) => { passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0; update(); }).observe(form);
  const footer = document.querySelector('footer.footer');
  if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; update(); }).observe(footer);
  mobile.addEventListener('change', update);
  bar.querySelector('button').addEventListener('click', () => {
    form.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    form.setAttribute('tabindex', '-1');
    form.focus({ preventScroll: true });
  });
})();
